import type { FeatureRoutes } from '@/app/screens'

export default {
  screens: { audit: () => import('./AuditLogPage.vue') },
} satisfies FeatureRoutes
